<app-header-title>
  <span title>عرض فترات عمل الموظف</span>
</app-header-title>

<app-general-calc-salary-inputs
  #salaryInputs
  [currentLang]="currentLang"
  (formDataChanged)="onFormDataChanged($event)">
</app-general-calc-salary-inputs>

<div style="padding: 1rem 3rem; margin-bottom: 1rem;">
  <dx-button
    style="margin-right: 1rem;"
    text="{{'search' | translate}}"
    type="normal"
    [width]="200"
    stylingMode="outlined"
    (onClick)="applyFilter()">
  </dx-button>
<dx-button
  style="margin-right: 1rem;"
  text="حذف المحدد"
  type="danger"
  [width]="200"
  stylingMode="outlined"
  (onClick)="deleteSelected()">
</dx-button>
  <dx-button
   style="margin-right: 1rem;"
    text="{{'reset' | translate}}"
    type="normal"
    [width]="200"
    stylingMode="outlined"
    (onClick)="resetFilter()">
  </dx-button>
</div>

<div class="publicsetting" style="padding: 0rem 3rem;">
  <dx-data-grid
    #dataGridVar
    class="dx-card wide-card"
    [dataSource]="gridDataSource"
    keyExpr="id"
    [showBorders]="false"
    [columnAutoWidth]="true"
    [allowColumnResizing]="true"
    [rtlEnabled]="currentLang=='ar'">
<dxo-selection mode="multiple"></dxo-selection>
    <dxo-pager [visible]="true"></dxo-pager>
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
<dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
    <dxi-column dataField="employeeId" caption="EmployeeId" [width]="110"></dxi-column>

    <dxi-column dataField="employeeName" caption="الموظف" [width]="220"></dxi-column>

    <dxi-column dataField="dateTimeRegister" caption="التاريخ" dataType="date" [width]="140"></dxi-column>

    <dxi-column dataField="day" caption="اليوم" [width]="120"></dxi-column>

    <dxi-column
      dataField="vacation"
      caption="إجازة"
      [width]="90"
      cellTemplate="vacTpl">
    </dxi-column>

    <div *dxTemplate="let cell of 'vacTpl'">
      {{ cell.value ? 'نعم' : 'لا' }}
    </div>

    <dxi-column dataField="durationWorkSystemId" caption="SystemId" [width]="110"></dxi-column>
    <dxi-column dataField="nameAr" caption="فترة العمل" [width]="150"></dxi-column>

    <dxi-column dataField="attendanceFromHour" caption="من" [width]="110"></dxi-column>
    <dxi-column dataField="leaveToHour" caption="إلى" [width]="110"></dxi-column>

    <dxi-column
      dataField="numberOfHours"
      caption="عدد الساعات"
      dataType="number"
      [width]="120">
    </dxi-column>
  </dx-data-grid>

  <dx-popup
  [(visible)]="showConfirmPopup"
  [width]="400"
  [height]="200"
  title="تأكيد الحذف"
  [rtlEnabled]="currentLang=='ar'">
  <div *dxTemplate="let data of 'content'">
    <p>هل أنت متأكد من حذف أوقات عمل الموظفين المحددين؟</p>
<p>عدد الأيام المحددة: <strong>{{ selectedItems.length }}</strong></p>
    <div style="display:flex; gap:1rem; justify-content:center; margin-top:1rem;">
      <dx-button
        text="تأكيد"
        type="danger"
        [width]="120"
        (onClick)="confirmDelete()">
      </dx-button>
      <dx-button
        text="إلغاء"
        type="normal"
        [width]="120"
        (onClick)="showConfirmPopup = false">
      </dx-button>
    </div>
  </div>
</dx-popup>

<!-- Result Popup -->
<dx-popup
  [(visible)]="showResultPopup"
  [width]="700"
  [height]="500"
  title="نتيجة الحذف"
  [rtlEnabled]="currentLang=='ar'">
  <div *dxTemplate="let data of 'content'" style="padding: 1rem;">

    <!-- Deleted -->
    <div *ngIf="deleteResult?.deletedEmployees?.length">
      <h4 style="color: green;">✔ تم الحذف بنجاح ({{ deleteResult.deletedEmployees.length }})</h4>
      <dx-data-grid
        [dataSource]="deleteResult.deletedEmployees"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [rtlEnabled]="currentLang=='ar'">
        <dxi-column dataField="employeeId" caption="كود الموظف" [width]="120"></dxi-column>
        <dxi-column dataField="employeeName" caption="اسم الموظف"></dxi-column>
      </dx-data-grid>
    </div>

    <!-- Failed -->
    <div *ngIf="deleteResult?.failedEmployees?.length" style="margin-top: 1rem;">
      <h4 style="color: red;">✘ فشل الحذف ({{ deleteResult.failedEmployees.length }})</h4>
      <dx-data-grid
        [dataSource]="deleteResult.failedEmployees"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [rtlEnabled]="currentLang=='ar'">
        <dxi-column dataField="employeeId" caption="كود الموظف" [width]="120"></dxi-column>
        <dxi-column dataField="employeeName" caption="اسم الموظف" [width]="200"></dxi-column>
        <dxi-column dataField="reason" caption="السبب"></dxi-column>
      </dx-data-grid>
    </div>

    <div style="text-align:center; margin-top:1rem;">
      <dx-button
        text="إغلاق"
        type="normal"
        [width]="120"
        (onClick)="showResultPopup = false">
      </dx-button>
    </div>
  </div>
</dx-popup>

</div>
